module.exports = require('./lib/client').Service;
